import React, {Dispatch, startTransition} from "react";
import { FilterValue, getCuisineDisplayLabel, TIME_FILTERS } from "../types/types";

interface inputFilterInterface {
    value : string,
    displayValue?: string,
    show : boolean,
    id: string,
    listFilter: (string | [number,number])[],
    setListFilter: Dispatch<React.SetStateAction<(string | [number,number])[]>>,
    isCuisine?:boolean,
    isLocked?: boolean;
}

const InputFilter:React.FC<inputFilterInterface> = ({value,show,id,displayValue,listFilter,setListFilter,isCuisine=false,isLocked=false}) => {
    const isChecked = listFilter.some(
        (elem) => elem === value
    );
    const clickInput = () => {
        if(isLocked) return;
        startTransition(() => {
            setListFilter((previous) => {
                const alreadySelected = previous.some((elem) => elem === value);

                if (alreadySelected) return previous.filter((elem) => elem !== value);
                if (TIME_FILTERS.has(value)) {
                    const withoutOtherTimeFilters = previous.filter((elem) =>typeof elem !== "string" ||!TIME_FILTERS.has(elem) );
                    return [...withoutOtherTimeFilters,value];
                }
                return [...previous,value,];
            });
        });
    };
    const formatValue = (value: FilterValue) => {
        if (Array.isArray(value)) return `${value[0]}€ - ${value[1]}€`;   
        if (typeof value === 'number') return `${value}km`; 
        return value;
    };
    return (
        <>

        {   show &&
            <div className={`content ${isChecked ? 'isSelect' : ''} pointer`} onClick={clickInput}>
                <span className={`XsmallText `} >{isCuisine ? getCuisineDisplayLabel(value) : displayValue ?? formatValue(value)}</span>        
            </div>
        }
        </>
    )
}

export { InputFilter }